import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { TComplimentaryProductsState } from 'pages/calculation/types/complimentary-products-state.type';

type TParams = {
  prevState: TComplimentaryProductsState;
  newCountValue: string;
  product: TComplimentaryProductInfo;
};

export const changeComplimentaryProductCountValue = ({
  prevState,
  newCountValue,
  product,
}: TParams): TComplimentaryProductsState => ({
  ...prevState,
  [product.productId]: {
    ...prevState[product.productId],
    total: {
      ...prevState[product.productId].total,
      requiredQuantity: Number(newCountValue),
    },
    isSelectedAsVariant: false,
  },
});
